export const CONSTANTS = {
  LOADING: $localize`Loading...`,
  PDF: $localize`Converting Data to PDF...`,
};
